import { Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function DialogAlert({
  message,
  setVisible,
  visible,
}: {
  message: string;
  setVisible: (value: boolean) => void;
  visible: boolean;
}) {
  return (
    <Collapse in={visible}>
      <Alert
        action={
          <IconButton size="small" onClick={() => setVisible(false)}>
            <CloseIcon />
          </IconButton>
        }
        severity="error"
      >
        {message}
      </Alert>
    </Collapse>
  );
}
